import React from "react";
import { Link } from "react-router-dom";

function Ui() {
  return (
    <>
      <div className=" w-full justify-center text-[#ffff] h-auto bg-no-repeat bg-cover bg-fixed text-center
    pt-40 pb-20  bg-[#6466ec]"
        Style="background-image: url('./image/full-stack/img1.svg')"
      >
        <p className="py-2 font-semibold text-[#ee2da4] ">Design Services</p>
        <h5 className=" uppercase text-2xl font-bold">
          On-Demand UI/UX Design Teams
        </h5>
        <p className="px-20 py-4">Take your customer-facing assets to the next level with an instantly deployable design team today.</p>
        <Link to="/contact">
          <button className="btn  btn-success uppercase text-white duration-600 mt-4 mb-4 mx-2 border-0 rounded-none bg-[#ee2da4] text-sm font-bold px-6 py-2">Get Started </button></Link>
      </div>
      <div className="  container pt-20 ">
        <h5 className=" text-3xl text-center">
          Amaze Your Audience with Impressive Design
        </h5>
        <p className="py-2 justify-center text-center">Ready to put a talented UI/UX design team to work for your next project? Check out our step-by-step design process below.</p>
        <div className="row pt-1 pb-4">
          <div class="card border-none m-2" Style="width: 22rem;">

            <div class="card-body ">
              <p className="py-2 font-semibold text-[#ee2da4] ">Phase One</p>
              <h5 class="card-title font-semibold text-xl hover:text-[#ee2da4] ">Discuss Your Vision</h5>
              <p class="card-text pb-2">To create web and mobile assets that effectively communicate the benefits of your products and the voice of your brand, we’ll first need to understand your unique vision. Sometimes, this stage is as simple as listening to you present your ideas. Other projects require more discussion. In either case, we never proceed until we are confident that we are 100% aligned with your goals.</p>
            </div>
          </div>

          <div class="card border-none m-2" Style="width: 22rem;">

            <div class="card-body "><p className="py-2 font-semibold text-[#ee2da4] ">Phase Two</p>
              <h5 class="card-title font-semibold text-xl hover:text-[#ee2da4] ">Research Your Users</h5>
              <p class="card-text pb-2">We’ve got an end goal – now let’s make it happen. By combining extensive market research with in-depth competitor and audience analysis, our design team gains accurate, actionable insights into how users will interact with your finished product.</p>
            </div>
          </div>

          <div class="card border-none m-2" Style="width: 22rem;">

            <div class="card-body "> <p className="py-2 font-semibold text-[#ee2da4] ">Phase Three</p>
              <h5 class="card-title font-semibold text-xl hover:text-[#ee2da4]  ">Wireframes & Prototype</h5>
              <p class="card-text pb-2">It’s time to take steps towards making your design a living, breathing reality. Using the info from the first two stages, we’ll create wireframes and prototypes that highlight the potential look and feel of the finished product. We’ll also collaborate with the project’s development team to get some feedback on the technical aspects of the design. </p>
            </div>
          </div>

        </div>
      </div>



      <div className=" bg-[#0003a1] w-full justify-center text-[#000] h-auto bg-no-repeat bg-cover bg-fixed pt-20 ">
        <h5 className="text-[#ffff] font-bold my-4 text-4xl text-center">
          Our Process
        </h5>
        <div className="section2 px-4  ">
          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border rounded-full text-center pt-2 font-bold w-10 h-10 ml-4 hover:bg-[#ee2da4]  hover:text-[#fff] bg-[#000] text-[#ffff]">1</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Define</h5>
              <p class="card-text pb-2">Kick off development by defining all system requirements, making initial technology decisions, and capturing user roles and personas.</p>
            </div>
          </div>

          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border rounded-full text-center pt-2 font-bold w-10 h-10 ml-4 hover:bg-[#ee2da4]  hover:text-[#fff] bg-[#000] text-[#ffff]">2</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Design</h5>
              <p class="card-text pb-2">Determine your product's initial look and feel, model the user experience and user journey, prioritize features, and plan for the release.</p>
            </div>
          </div>

          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border rounded-full text-center pt-2 font-bold w-10 h-10 ml-4  hover:bg-[#ee2da4]  hover:text-[#fff] bg-[#000] text-[#ffff]">3</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Deliver</h5>
              <p class="card-text pb-2">Move forward with detailed, development-ready specs, time and cost estimates, a launch plan, and a team of MsCube Tech experts ready to execute your plan.</p>
            </div>
          </div>

          <div class="card mx-1 border-none my-2 pt-4 py-2" Style="width: 20rem;">
            <h1 className="border rounded-full text-center pt-2 font-bold w-10 h-10 ml-4 hover:bg-[#ee2da4]  hover:text-[#fff] bg-[#000] text-[#ffff]">4</h1>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">Develop</h5>
              <p class="card-text pb-2">Throughout the product development phase, track quality assurance, DevOps, and deployment updates using the project management tool you prefer.</p>
            </div>
          </div>

        </div>
        <div className="section2 h-auto mt-20 text-[#ffff] bg-[#6a6dec] ">
          <h1 className=" pt-10 px-10 text-white text-2xl">Buil great products with UI/UX Design service.!</h1>
          <button className="border font-bold text-white my-10 mx-10 px-4 py-2 bg-[#ce2e90]">Get Started</button>

        </div>
      </div>


      <div className="  w-full justify-center text-center text-[#000] h-auto py-40 bg-no-repeat bg-cover pt-20 "
         Style="background-image: url('./image/design/p1.png')">
        <div className="justify-center text-center px-2">
        <h5 className="text-[#000] uppercase font-semibold  text-2xl py-40  text-center">
          Tools We Use To Design Amazing Experiences
        </h5>
        {/* <img className="justify-center  px-4" src="./image/design/p1.png" alt="" /> */}
      </div>
</div>

      <div className=" w-full justify-center text-center h-auto pt-20 ">
        <h5 className=" py-4 text-2xl text-center uppercase font-semibold">
          Projects
        </h5>
        <p className="py-2 uppercase font-semibold">Our latest Complete Projects</p>
        <div className="section2 justify-center text-center m-0 p-0">
          <Link to="/app-development" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/app/p7.png" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">Facebook App Project </h5>
              </div>
            </div>
          </Link>
          <Link to="/app-development" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/app/p6.jpg" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">Whatsapp App Project </h5>
              </div>
            </div>
          </Link>
          <Link to="/app-development" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/app/p5.png" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">Calculator app Project </h5>
              </div>
            </div>
          </Link>

        </div>
        <div className="section2 justify-center text-center m-0 p-0">

          <Link to="/app-development" class=" font-bold  hover:text-[#ee2da4]  ">
            <div class="card border-0 rounded-none m-2" Style="width: 22rem;">
              <img src="./image/app/p4.jpg" class="h-52 p-0 m-0 card-img-top rounded-none" alt="..." />
              <div class="card-body  ">
                <h5 class=" text-center card-title font-semibold text-2xl">New Project </h5>
              </div>
            </div>
          </Link>

        </div>
        <div className="  text-center  justify-center pt-40 h-screen ">
          <h5 className="font-semibold text-3xl text-center">
            Related Services
          </h5>
          <p className="py-2 mb-8">MsCube Tech wide selection of related services are tailored to your company needs and delivered by accomplished experts from our global talent network.</p>
          <div className="row  w-100 justify-center">

            <div class="card border shadow-md hover:bg-[#ee2da4] hover:shadow-lg p-2 hover:text-[#fff] justify-center text-center border-none m-2" Style="width: 20rem;">
              <Link to="/frontend">
                <img src="./image/full.gif" Style="width: 6rem;" class="  px-2 p-0 mx-24 card-img-top" alt="..." />
                <div class=" hover:text-[#fff]">
                  <h5 class=" font-semibold py-1 text-2xl hover:text-[#fff]">Front-End Development</h5>
                  <p class="card-text pb-2 font-bold text-xl">Services</p>
                </div>
              </Link>
            </div>

            <div class="card border shadow-md hover:bg-[#ee2da4] hover:shadow-lg p-2 hover:text-[#ffffff] justify-center text-center border-none m-2" Style="width: 20rem;">
              <Link to="/product-design">
                <img src="./image/ui.gif" Style="width: 6rem;" class="  px-2 p-0 mx-24 card-img-top" alt="..." />
                <div class="hover:text-[#fff] ">
                  <h5 class=" font-semibold py-1 text-2xl  hover:text-[#fff]">Product Design Services</h5>
                  <p class="card-text pb-2 font-bold text-xl">Services</p>
                </div>
              </Link>
            </div>


            <div class="card border shadow-md hover:bg-[#ee2da4] hover:shadow-lg p-2 hover:text-[#ffffff] justify-center text-center border-none m-2" Style="width: 20rem;">
              <Link to="/app-development">
                <img src="./image/app.gif" Style="width: 6rem;" class="  px-2 p-0 mx-24 card-img-top" alt="..." />
                <div class="hover:text-[#fff] ">
                  <h5 class=" font-semibold py-1 text-2xl hover:text-[#fff]">App Development</h5>
                  <p class="card-text pb-2 font-bold text-xl">Services</p>
                </div>
              </Link>
            </div>

          </div>


      
        </div>


      <div className=" py-4 w-full h-auto bg-no-repeat justify-center text-center bg-cover bg-fixed">
        <div className="text-center pt-80 text-neutral-110">
          <h4 className="tracking-wide text-2xl font-bold	 ">
          UI/UX design specialists are just a few clicks away.
          </h4>
          <p>Start building your design dream team today.</p>
        </div>

        <Link to="/contact">
          <button className="btn btn-success border-0 py-2 uppercase font-bold hover:text-[#000]  text-white duration-600 mt-3  mx-2 rounded-none bg-[#ee2da4] text-sm">Free Consultation </button></Link>
      

      </div>
      </div >
    </>
  );
}

export default Ui;
